export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/login';
export const PASSWORD_FORGET = '/forget';
export const PASSWORD_CHANGE = '/change';
export const HOME = '/home';
export const ACCOUNT = '/account';
